import React from 'react';
import { motion } from 'framer-motion';
interface QuestionSlideProps {
  questionNumber: number;
  totalQuestions: number;
  question: string;
  subtitle?: string;
  options: string[];
  onAnswer: (answer: string) => void;
}
export function QuestionSlide({
  questionNumber,
  totalQuestions,
  question,
  subtitle,
  options,
  onAnswer
}: QuestionSlideProps) {
  return <div className="w-full min-h-screen flex items-center justify-center bg-[#FAFAF8] px-6 py-20" data-id="element-143">
      <div className="w-full max-w-xl space-y-8" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="space-y-3" data-id="element-145">
          <span className="inline-block px-3 py-1 bg-neutral-200 text-neutral-700 text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-146">
            Question {questionNumber} of {totalQuestions}
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-[#1C1917] leading-snug" data-id="element-147">
            {question}
          </h2>
          {subtitle && <p className="text-sm text-[#57534E]" data-id="element-148">{subtitle}</p>}
        </motion.div>

        <div className="space-y-3" data-id="element-149">
          {options.map((option, index) => <motion.button key={option} initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.3,
          delay: 0.05 * index
        }} whileHover={{
          x: 4
        }} whileTap={{
          scale: 0.98
        }} onClick={() => onAnswer(option)} className="w-full text-left px-5 py-4 bg-white rounded-xl border border-neutral-100 shadow-sm hover:border-teal-400 hover:shadow-md transition-all group" data-id="element-150">
              <span className="text-base font-medium text-[#1C1917] group-hover:text-teal-700 transition-colors" data-id="element-151">
                {option}
              </span>
            </motion.button>)}
        </div>
      </div>
    </div>;
}